module.exports = __webpack_public_path__ + "flyer_image_overlay_blue_pink_gradient_11-51f6a3cbb1819acfc588c6c803a7af96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/flyer_image_overlay_blue_pink_gradient_11.png
// module id = 1559
// module chunks = 1